
var firebaseConfig = {
    apiKey: "AIzaSyBdnJGn85Zl3B9vXyRoREOj1Q77jfQL2Kw",
    authDomain: "tw-01-382310-default-rtdb.europe-west1.firebasedatabase.app",
    // The value of `databaseURL` depends on the location of the database
    databaseURL: "https://tw-01-382310-default-rtdb.europe-west1.firebasedatabase.app",
    
    projectId: "tw-01",
    //storageBucket: "PROJECT_ID.appspot.com",
    //messagingSenderId: "SENDER_ID",
    appId: "tw-01",
    // For Firebase JavaScript SDK v7.20.0 and later, `measurementId` is an optional field
    // measurementId: "G-MEASUREMENT_ID",
};
export {firebaseConfig}

const firebase_dbpath = 'link-tree-logic-moon2'
export {firebase_dbpath}